/** Client-side validation for login / sign-up forms (i18n keys). */

export const MIN_PASSWORD_LENGTH = 8;

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmailFormat = (email) => EMAIL_PATTERN.test(normalizeEmail(email));

const normalizeEmail = (email) => (email ?? '').trim();

export const validateSignInFields = ({ email, password }) => {
  const errors = {};
  if (!normalizeEmail(email)) {
    errors.email = 'auth.error.emptyEmail';
  } else if (!isValidEmailFormat(email)) {
    errors.email = 'auth.error.invalidEmail';
  }
  if (password === undefined || password === null || String(password).trim() === '') {
    errors.password = 'auth.error.emptyPassword';
  }
  return errors;
};

export const validateResetEmailField = (email) => {
  const errors = {};
  if (!normalizeEmail(email)) {
    errors.email = 'auth.error.emptyEmail';
  } else if (!isValidEmailFormat(email)) {
    errors.email = 'auth.error.invalidEmail';
  }
  return errors;
};

export const validateSignUpFields = ({ email, password, passwordConfirm }) => {
  const errors = validateSignInFields({ email, password });
  if (String(password).length > 0 && String(password).length < MIN_PASSWORD_LENGTH) {
    errors.password = 'auth.error.weakPassword';
  }
  if (passwordConfirm === undefined || String(passwordConfirm).trim() === '') {
    errors.passwordConfirm = 'auth.error.emptyPassword';
  } else if (password !== passwordConfirm) {
    errors.passwordConfirm = 'auth.validation.passwordMismatch';
  }
  return errors;
};

export const getPasswordStrengthLevel = (password) => {
  const len = String(password ?? '').length;
  if (len === 0) {
    return null;
  }
  if (len < MIN_PASSWORD_LENGTH) {
    return 'weak';
  }
  if (len < 12) {
    return 'fair';
  }
  return 'strong';
};
